import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=24a018fb&scoped=true"
import script from "./CreateCampaign.vue?vue&type=script&lang=js"
export * from "./CreateCampaign.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaign.vue?vue&type=style&index=0&id=24a018fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a018fb",
  null
  
)

export default component.exports